import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import useCurrentAccounts from '../../../../hooks/useCurrentAccounts';

import './style.scss';

const ServicesAccountPage: React.FC = () => {
  const { t } = useTranslation();
  const { connectedAccounts } = useCurrentAccounts();

  return (
    <div className="AccountServices">
      {connectedAccounts.length > 0
        ? (
          <>
            <div className="AccountServices__subtitle">
              <span>{t('mijn_vnl.services.title_head')}</span>
            </div>
            <div className="AccountServices__list">
              {connectedAccounts.map(({
                url,
                body,
                icon,
                label,
              }) => (
                <div className="AccountServices__list__item">
                  <div className="AccountServices__list__item__title">
                    <div className="icon-wrapper">
                      <i className={`icon ${icon}`} />
                    </div>
                    <span>{label}</span>
                  </div>
                  <div className="AccountServices__list__item__body">
                    <span>{body}</span>
                  </div>
                  <Button
                    href={url}
                    primary={false}
                    className="AccountServices__list__item__button"
                  >
                    <span>{t('buttons.external_application')}</span>
                  </Button>
                </div>
              ))}
            </div>
          </>
        )
        : (
          <div>{t('mijn_vnl.services.no_linked_accounts')}</div>
        )}
    </div>
  );
};

export default ServicesAccountPage;
